<template>
  <div class="add-step">
    <div class="bg-black add-accont-header">
      <div class="add-brd">
        <div class="h-back" @click="goBackHandler">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </div>
        <h2>تایید بانکی</h2>
        <p>مرحله پایانی</p>
      </div>
      <div>
        <svg class="header-progresbar">
          <circle class="meter" cx="57" cy="57" r="42" />
          <circle class="meter-2" cx="57" cy="57" r="42" />
          <text class="SVG-text" x="37" y="47">مرحله</text>
          <text x="65" y="74" class="SVG-text">4</text>
          <text x="50" y="74" class="SVG-text">از</text>
          <text x="37" y="74" class="SVG-text">4</text>
        </svg>
      </div>
    </div>
    <div class="add-card">
      <p class="head-step2">
        ما برای انکه بتوانیم از شما به صورت مکرر و خودکار برداشت وجه داشته باشیم
        به اجازه شما نیاز داریم.
      </p>
      <button class="m-btn add-confer-btn" @click="creatAccountHandler">
        تایید
      </button>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {},
  data() {
    return {
      creatModel: {},
    };
  },
  methods: {
    goBackHandler() {
      this.$router.back();
    },
    creatAccountHandler() {
      this.creatModel = this.$store.state.accounts.model;
      if (
        this.creatModel.bank.name.toLowerCase() == "ayandeh" ||
        this.creatModel.bank.name.toLowerCase() == "keshavarzi"
      ) {
        delete this.creatModel.card_number;
        delete this.creatModel.is_default;
        this.$store
          .dispatch("accounts/addFinoAccount", this.creatModel)
          .then((rsp) => {
            window.location.href = rsp.url;
          });
      } else if (
        this.creatModel.bank.name.toLowerCase() == "saman" ||
        this.creatModel.bank.name.toLowerCase() == "eghtesadnovin"
      ) {
        this.$store
          .dispatch("accounts/addFaraboomAccount", this.creatModel)
          .then((rsp) => {
            window.location.href = rsp.url;
          });
      } else {
        this.$store
          .dispatch("accounts/addAccount", this.creatModel)
          .then((rsp) => {
            window.location.href = rsp.url;
          });
      }
    },
  },
};
</script>

<style scoped>
.head-step2 {
  margin-top: 50px;
  font-size: 20px;
}
</style>
